import { ArrowLeft, Filter, Loading2, SearchLoop } from 'assets/icons/index.js';
import axios from 'axios';
import ApiDatabase from 'server';
import Button from 'components/button/index.js';
import useModal from 'components/modal/useModal.js';
import Pagination from 'components/pagination/pagination.js';
import useWindowDimensions from 'hooks/useWindowDimensions.js';
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SubNavbar from '../../../../../components/SubNavbar/SubNavbar.js';
import TableListVivier from './components/table.list.vivier.js';
import StyledInput from '../../../../../components/styledInput/StyledInput';
import MediaQuery from 'react-responsive';
import BottomSheet from '../../../../../components/bottomSheet/BottomSheet';

function ListBodyVivier() {
  const { toggle } = useModal();
  const navigate = useNavigate();
  const location = useLocation();
  const { height, width } = useWindowDimensions();
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [departments, setDepartments] = useState([]);
  const [searchVivierWaiting, setSearchVivierWaiting] = useState(true);
  const [sortName, setSortName] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitElement, setLimitElement] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [result, setResult] = useState([]);
  const token = localStorage.getItem('xsrfToken');
  const debounceTimer = useRef(null);
  //get params from url
  const params = new URLSearchParams(window.location.search);
  const searchListVivier = params.get('searchListVivier');
  const pageListVivier = params.get('pageListVivier');
  const selectedVivier = params.get('selectedVivier');

  // États pour le BottomSheet mobile
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState('');

  const openFilterSheet = () => {
    setTempSearch(search);
    setIsFilterOpen(true);
  };

  const applyFilters = () => {
    setSearch(tempSearch);
    setIsFilterOpen(false);
  };

  // #region **** Handle Click ****
  const handleCreate = () => {
    toggle('vivier_create');
  };

  // #endregion **** Handle Click ****
  
  // #region **** UseEffect ****
  // Debounce la recherche pour éviter trop de requêtes
  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      setDebouncedSearch(search);
      // Reset page quand la recherche change
      if (search !== debouncedSearch) {
        setCurrentPage(1);
      }
    }, 300);
    
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [search]);

  useEffect(() => {
    ApiDatabase.getCityDepartments({ token }, (data) => {
      setDepartments(data);
    }, () => {});
  }, []);

  // UN SEUL useEffect pour charger les viviers
  useEffect(() => {
    let isCancelled = false;
    const controller = new AbortController();
    
    const loadViviers = async () => {
      setSearchVivierWaiting(true);

      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}vivier/vivierAllPage`,
          {
            signal: controller.signal,
            params: {
              token: token,
              page: currentPage,
              limit: limitElement,
              search: debouncedSearch,
              sortName: sortName,
            },
          }
        );

        if (!isCancelled) {
          setResult(data.viviers || []);
          setCountTotal(data.count || 0);
          setTotalPages(data.countPages || 0);
          setCountPerPage(data.countPerPage || 0);
          setSearchVivierWaiting(false);
        }
      } catch (error) {
        if (!isCancelled && error.name !== 'CanceledError') {
          console.error('An error occurred:', error);
          setSearchVivierWaiting(false);
        }
      }
    };

    loadViviers();

    return () => {
      isCancelled = true;
      controller.abort();
    };
  }, [token, currentPage, limitElement, debouncedSearch, sortName]);

  const navigateToFicheVivier = (idVivier) => {
    //if search and currentPage, add in the url
    navigate(
      `../ficheVivier/${idVivier}?searchListVivier=${search}&pageListVivier=${currentPage}`
    );
  };

  useEffect(() => {
    if (searchListVivier) setSearch(searchListVivier);
    if (pageListVivier)
      setCurrentPage(parseInt(pageListVivier) ? parseInt(pageListVivier) : 1);
  }, [searchListVivier, pageListVivier, selectedVivier]);

  // #endregion **** UseEffect ****

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <SubNavbar>
        <div className="flex justify-between items-center w-full gap-3">
          {/* Desktop: Left side - Search */}
          <MediaQuery minWidth={768}>
            <div className="flex-1 overflow-x-auto overflow-y-hidden" style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              <div className="flex gap-3 items-center min-w-max">
                <div className="w-full tab:flex-1 tab:max-w-[400px]">
                  <StyledInput
                    type="text"
                    placeholder="Rechercher..."
                    imgFront={<SearchLoop wh={16} color="#6B7280" />}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </MediaQuery>
          {/* Mobile: Filter button */}
          <MediaQuery maxWidth={767}>
            <div className="flex items-center gap-3 min-w-max">
              <Button
                color={'SECONDARY'}
                size={'SM'}
                onClick={openFilterSheet}
              >
                <Filter wh={16} color="#374151" />
                <span>Filtrer</span>
              </Button>
            </div>
          </MediaQuery>
        </div>
      </SubNavbar>
      <div className="flex flex-col w-full h-full overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          {searchVivierWaiting && (
            <div className="p-3 tab:p-4 lg:p-8">
              <div
                className={`flex flex-col ${
                  width <= 460 ? 'gap-5' : 'gap-10'
                } justify-center items-center h-80`}
              >
                <div className={'animate-spin'}>
                  <Loading2 wh={width <= 460 ? 40 : 60} color={'#FF9600'} />
                </div>
              </div>
            </div>
          )}
          {!searchVivierWaiting && (
            <div>
              <TableListVivier
                viviers={result}
                isWaiting={searchVivierWaiting}
                setSortName={setSortName}
                sortName={sortName}
                navigateToFicheVivier={navigateToFicheVivier}
                departments={departments}
              />
            </div>
          )}
        </div>
        {totalPages >= 1 ? (
          <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
            <Pagination
              currentPage={currentPage}
              countPerPage={countPerPage}
              countTotal={countTotal}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </div>
        ) : null}
      </div>

      {/* Bottom Sheet Filtre pour mobile */}
      <BottomSheet
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        title="Filtrer"
      >
        <div className="flex flex-col gap-4">
          {/* Recherche */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rechercher
            </label>
            <StyledInput
              type="text"
              placeholder="Rechercher..."
              imgFront={<SearchLoop wh={16} color="#6B7280" />}
              value={tempSearch}
              onChange={(e) => setTempSearch(e.target.value)}
            />
          </div>

          {/* Bouton Appliquer */}
          <div className="mt-2">
            <Button
              color={'PRIMARY'}
              size={'FULL'}
              onClick={applyFilters}
            >
              Appliquer
            </Button>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
}

export default ListBodyVivier;
